import * as types from '@/store/types';

export default {
  async listFavorites({ commit }, payload) {
    try {
      const { data } = await axios.get(
        `/api/web/favorites?page=${payload.page}&search=${payload.search_user}&filter=${payload.filter}`
      );
      commit(types.LIST_FAVORITES, { favorites: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async listFavoritesReciprocal({ commit }, payload) {
    try {
      console.warn(payload)
      const { data } = await axios.get(
        `/api/web/favorites/reciprocal?page=${payload.page}&search=${payload.search_user}&filter=${payload.filter}`
      );
      commit(types.LIST_RECIPROCAL, { reciprocal: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async showSeen({ commit }) {
    try {
      const { data } = await axios.get(`/api/web/seen/counts`);
      commit(types.LIST_SEEN, { seen: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async listProfileSeen({ commit }, payload) {
    try {
      const { data } = await axios.get(
        `/api/web/seen?page=${payload.page}&search=${payload.search_user}&filter=${payload.filter}`
      );
      commit(types.SEEN_PROFILES, { seenProfile: data });
      return data;
    } catch (e) {
      return null;
    }
  }
};
